<template>
  <div class="search-box">
    <div class="ipt-box">
      <form
        action="javascript:return true"
        @submit.prevent="formSubmit"
      >
        <input
          v-model="searchText"
          class="searchInput"
          type="search"
          v-bind:placeholder="placeholderTxt"
          @input="entry()"
        >
      </form>
      <div class="icon-box">
        <i class="iconfont icon-sousuo icon" />
      </div>
      <div class="mask-box" />
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, ref, watch } from 'vue';

defineOptions({name: 'CitySearch'});

const props = defineProps({
  clearText: Boolean,
  canSearchSpell: {
    type: Boolean,
    default: true
  }
});

const emit = defineEmits(['txtdata']);
const searchText = ref('');
let timer = null;

const placeholderTxt = computed(() => (
  props.canSearchSpell ? '请输入城市名或拼音' : '请输入城市名'
));

watch(() => props.clearText, value => {
  if (value) {
    searchText.value = '';
    entry();
  }
});

onBeforeUnmount(() => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
});

function formSubmit () {
  emit('txtdata', searchText.value);
}

// 延时搜索
function entry () {
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout(() => {
    emit('txtdata', searchText.value);
    timer = null;
  }, 300);
}
</script>
<style scoped>
.search-box {
  height: 100%;
  width: 78%;
  margin: 0 auto;
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.search-box > .ipt-box {
  width: 95%;
  position: relative;
  height: 36px;
  border: 1px solid var(--border-strong);
  border-radius: 18px;
  background: var(--surface-soft);
  padding-top: 0;
  box-sizing: border-box;
  overflow: hidden;
}
.search-box > .ipt-box > form {
  width: 100%;
  height: 100%;
}
.searchInput {
  display: block;
  width: 114.2857%;
  padding-left: 42px;
  padding-right: 16px;
  border: none;
  outline: none;
  border-radius: 18px;
  box-sizing: border-box;
  font-size: 16px;
  font-family: inherit;
  background: var(--surface-soft);
  color: var(--text-main);
  line-height: 41.1429px;
  height: 41.1429px;
  transform: scale(0.875);
  transform-origin: left top;
}
.searchInput::placeholder {
  color: var(--text-faint);
}
input::-webkit-clear {
  display: none;
}
.search-box > .ipt-box > .icon-box {
  position: absolute;
  top: 0;
  left: 14px;
  margin-left: 0;
  z-index: 50;
  width: 18px;
  height: 36px;
  line-height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}
.search-box > .ipt-box > .mask-box {
  display: none;
}
.search-box > .ipt-box > .icon-box > .icon {
  color: var(--text-faint);
  font-size: 18px;
  font-weight: normal;
}
</style>
